module.exports = __webpack_public_path__ + "img/hmark_logo_compressed2.5065c5f8.png";